

export default getUniqueNames;
import hasOwnProp from 'utils/hasOwnProp';
import builtins from 'utils/builtins';
import { default as sanitize, splitPath } from 'utils/sanitize';
function getUniqueNames(bundle) {
	var modules = bundle.modules;
	var externalModules = bundle.externalModules;

	var userNames = bundle.names;
	var names = {};

	var used = modules.reduce(function (declared, mod) {
		var defaultExport = mod.defaultExport;
		var defaultExportName = defaultExport && !defaultExport.unsafe && defaultExport.type === 'expression' && defaultExport.node.declaration && defaultExport.node.declaration.type === 'Identifier' && defaultExport.node.declaration.name;

		Object.keys(mod.ast._declared).forEach(function (x) {
			// special case - `export default foo`
			if (x === defaultExportName) return;
			declared[x] = true;
		});
		return declared;
	}, {});

	// copy builtins
	builtins.forEach(function (n) {
		return used[n] = true;
	});

	// copy user-specified names
	if (userNames) {
		Object.keys(userNames).forEach(function (id) {
			names[id] = userNames[id];
			used[userNames[id]] = true;
		});
	}

	// infer names from default imports - e.g. with `import _ from './utils'`,
	// use '_' instead of generating a name from 'utils'
	function inferName(x) {
		if (x.isDefault && !hasOwnProp.call(names, x.module.id) && !hasOwnProp.call(used, x.as)) {
			names[x.module.id] = x.as;
			used[x.as] = true;
		}
	}
	modules.forEach(function (mod) {
		mod.imports.forEach(inferName);
	});

	// for the rest, make names as compact as possible without
	// introducing conflicts
	modules.concat(externalModules).forEach(function (mod) {
		// is this already named?
		if (hasOwnProp.call(names, mod.id)) {
			mod.name = names[mod.id];
			return;
		}

		var name = undefined;
		var parts = splitPath(mod.id);
		var i = parts.length;

		while (i--) {
			name = sanitize(parts.slice(i).join('_'));

			if (!hasOwnProp.call(used, name)) {
				break;
			}
		}

		while (hasOwnProp.call(used, name)) {
			name = '_' + name;
		}

		used[name] = true;
		mod.name = name;
	});

	return names;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/combine/populateModuleNames.js.01-babel.map